import { Link, Tooltip } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { yearFirstDateTimeFormatInTimezone } from "src/utils/timezoneFormat";

export const  serviceRequestListColumns = (isReadOnly,companyId,timeZone) => {
    const columns = [
        {
            field: "ticket_id",
            headerName: "Ticket ID",
            minWidth: 100,
            width: 120,
            resizable: true,
            renderCell: ({ value, row: { ticket_id } }) => (
                <>
                    {isReadOnly ? value : <Link underline="none" component={RouterLink} to={`edit/${ticket_id}`}>{value}</Link>}
                </>
            )
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
            minWidth:250,
            resizable: true,
        },
        {
            field: "companyName" || "teamName",
            headerName: "Company Name / Team Name",
            flex: 1,
            minWidth: 250,
            resizable: true,
            renderCell: ({ row }) => (
                <>
                    <span>{row.companyName} / {row.teamName}</span>
                </>
            )
        },
        {
            field: "issueType",
            headerName: "Issue Type",
            flex: 1,
            minWidth: 150,
            resizable: true
        },
        {
            field: "createAt",
            headerName: "Date/Time",
            flex: 1,
            minWidth: 180,
            resizable: true,
            type: "date",
            renderCell: ({ value }) => {
                const formatted = timeZone
                    ? yearFirstDateTimeFormatInTimezone(value, timeZone)
                    : yearFirstDateTimeFormat(value);
                return (
                    <Tooltip title={formatted} placement="top">
                        <span>{formatted}</span>
                    </Tooltip>
                );
            }
        },
        {
            field: "statusType",
            headerName: "Status",
            flex: 1,
            minWidth: 120,
            resizable: true
        },
    ];

    return columns;
};